import React, { useState, useEffect } from 'react';
import IframeResizer from 'iframe-resizer-react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { Document, Page, pdfjs } from "react-pdf";
import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';
// import axios from 'axios';
// import { selectedProduct, removeSelectedProduct } from '../redux/actions/productActions';
// import LoadingBox from '../components/LoadingBox';
// import Iframe from 'react-iframe';
import PageHelmet from '../components/helmet/PageHelmet'

import ProductDetailSpecification from '../components/product/ProductDetailSpecification';
import ProductDetailMarginBlock from '../components/product/ProductDetailMarginBlock';
import ProductDetailPriceBlock from '../components/product/ProductDetailPriceBlock';
import ProductDetailIcon from '../components/product/ProductDetailIcon';
import ProductDetailSlider from '../components/product/ProductDetailSlider';
import RelatedSaleItems from '../components/product/RelatedSaleItems';
import ProductDetailShorDescription from '../components/product/ProductDetailShorDescription';
import BlockActionSlider from '../components/blocks/BlockActionSlider';
import WishListButton from '../components/other/WishListButton';
import CompareButton from '../components/other/CompareButton';
import "../css/Product.css";

// import { connect } from 'react-redux';
import { getProductDetail, getProductRelatedSale, getLastProductsList, getProductSpecification } from '../redux/actions/productActions';
import { globalStatistic } from '../redux/actions/otherActions';

import globalVariable from '../global';

import { customLogger, removeSpecialChar } from '../helperFunctions'
import { useTranslation } from 'react-i18next';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const ProductDetailPage = (item, props) => {
    const dispatch = useDispatch();
    const params = useParams();
    const { productId } = params;

    const [tab, setTab] = useState(1);
    const [newProductId, setNewProductId] = useState(productId == 26348 ? 2996 : productId);
    const [itemsToShow, setItemsToShow] = useState(6);
    // const [isVoucher, setIsVoucher] = useState(0);
    // const [voucherData, setVoucherData] = useState({});


    const getUserInfo = useSelector((state) => state.userInfo);
    const clerkResponsible = getUserInfo?.userInfo?.company?.clerkResponsible?.['0'];
    const productDetailItem = useSelector((state) => state.productDetail);
    const getRelatedProducts = useSelector((state) => state.getRelatedCategoryProducts);
    const getLastProducts = useSelector((state) => state.getLastProducts);
    const productSpecificationList = useSelector((state) => state.getProductSpecification);
    const getSale = useSelector((state) => state.getProductRelatedSale);
    const iconPath = process.env.PUBLIC_URL + '/media/';

    // const getMenuItems = useSelector((state) => state.menuItems[1]);
    // const subMenu = getMenuItems ? getMenuItems.menu[1].subMenu.filter(x => x.acMenu === props.title) : [];


    const [youtubeImage, setYoutubeImage] = useState('');
    let videoApi = productDetailItem.items.length > 0 ? productDetailItem.items[0].urlImages.filter(i => i.acType == "video") : []

    var youtubeCode = videoApi.length > 0 ? videoApi[0].acImage : "";
    var youtubeKey = 'AIzaSyCcp3vQueKPj0OfU12LmKGF_xRaeJUl66E';
    var youtubeApi = 'https://www.googleapis.com/youtube/v3/videos?key=' + youtubeKey + '&part=snippet&id=' + youtubeCode + '';

    const [showActionInfo, setShowActionInfo] = useState(false);
    const [showActionKey, setShowActionKey] = useState();
    const { t } = useTranslation(['productDetailPage', 'routes']);
    const totalExternalStock = productDetailItem.anStock?.stockList.slice(1).reduce((acc, stock) => acc + stock.anStock, 0);
    const totalStock = productDetailItem.anStock?.stockList[0]?.anStock - productDetailItem?.anReserved + (totalExternalStock * productDetailItem.anStock?.stockList[0]?.isStockForSale);

    const showText = (key) => {
        setShowActionInfo(true)
        setShowActionKey(key)
    }

    const hideText = () => {
        setShowActionInfo(false)
    }


    function youtubeApiFunction() {
        axios.get(youtubeApi).then((response) => {
            if (response.data.items.length > 0) {
                setYoutubeImage(response.data.items[0].snippet.thumbnails.high.url);
            }
        });
    }

    useEffect(() => {
        if (videoApi.length > 0) {
            youtubeApiFunction();
        }
    }, [productDetailItem.items]);

    // setovanje vaucera ukoliko postoje
    // useEffect(() => {
    //     if (!productDetailItem.loading) {
    //         if (productDetailItem.items.length > 0) {
    //             if (productDetailItem.items[0].specialList !== undefined) {
    //                 if (productDetailItem.items[0].specialList.length > 0) {
    //                     productDetailItem.items[0].specialList.forEach(item => {
    //                         if (item.acSpecialName == 'Vaucer') {
    //                             setIsVoucher(1);
    //                             setVoucherData(item);
    //                         }
    //                     })
    //                 }
    //             }
    //         }
    //     }
    // }, [productDetailItem, voucherData]);

    const showMore = () => {
        let index;
        for (index = 12; index < getSale.length; index += 6) {
            if (index > itemsToShow) {
                setItemsToShow(index)
                break;
            }
        }
        if (index > getSale.length) {
            index = getSale.length
            setItemsToShow(index)
        }
    }

    const showLess = () => {
        setItemsToShow(6)
    }

    // f-ja gleda da li je skrol stigao do kraja stranice
    const handleScroll = () => {
        const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight
        if (bottom) {
            dispatch(globalStatistic(newProductId, 'END_PRODUCT'));
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const gatherStatisticMakeOffer = () => {
        dispatch(globalStatistic(newProductId, 'OFFER_PRODUCT'));
    }

    const gatherStatisticDesc = () => {
        dispatch(globalStatistic(newProductId, 'DESCRIPTION_TAB_PRODUCT'));
    }

    const gatherStatisticSpec = () => {
        dispatch(globalStatistic(newProductId, 'SPRCIFICATION_TAB_PRODUCT'));
    }

    // Dodato zbog tendera na kom su greškom stavili pogrešan id u link, pa je potrebno da se preusmeri na pravi - Ivan 13.03.2024.
    // Potrebno je vratiti na stari kod kada tender bude završen
    useEffect(() => {
        if (productId == 26348) {
            setNewProductId('2996');
        } else {
            setNewProductId(productId);
        }
    }, [productId]);
    useEffect(() => {
        dispatch(getProductDetail(newProductId));
        dispatch(getProductRelatedSale(newProductId));
        dispatch(getLastProductsList());
        dispatch(globalStatistic(newProductId, 'PRODUCT'));
        dispatch(getProductSpecification(newProductId));
        customLogger('other', 'productDetailItem', productDetailItem)
    }, [newProductId]);

    if (productDetailItem.loading) {
        return null;
    } else if (productDetailItem.items.length == 0 && !productDetailItem.loading) {
        return <div className="page-not-found-container container-fluid" >
            <div className="col-page-not-found-block col-page-not-found-block-image">
                <img loading="lazy" src="/images/404-error2.jpg" className="img-fluid" alt="404" />
            </div>
            <div className="col-page-not-found-block">
                <div className="content-not-found-block">
                    <div className="content-not-found-block">
                        <div
                            className="content-not-found-block-subtitle"
                            dangerouslySetInnerHTML={{ __html: t('strNijePronadjena') }}
                        ></div>
                        <div className="content-not-found-block-desc not-f-page"
                            dangerouslySetInnerHTML={{ __html: t('urlNijePronadjen') }}
                        ></div>
                        <div className="content-not-found-block-button">
                            <Link to="/">
                                <button className="btn btn-success">{t('povratakNaPocetnu')}</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    return (
        <div className="container-content product-detail-content-box">
            <PageHelmet
                title={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoTitle}` : ""}
                description={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoDescription}` : ""}
                keywords={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoKeywords}` : ""}
                ogDescription={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoDescription}` : ""}
                ogTitle={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoTitle}` : ""}
                ogUrl={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `https://ewe.rs${window.location.pathname}` : ""}
                ogImg={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 && productDetailItem.items[0].urlImages.length > 0 ? productDetailItem.items[0].urlImages[0].acImage : "https://www.ewe.rs/ewe-login.png"}
                ogType="product"
                twitterDescription={productDetailItem && productDetailItem.items && productDetailItem.items.length > 0 ? `${productDetailItem.items[0].acSeoDescription}` : ""}
            />
            <div className="container-fluid">
                {productDetailItem.items.length > 0 && (
                    <>
                        <div className="col-lg-12">
                            {productDetailItem.items[0].urlImages.length == 0 ? (
                                <div className="text-center">
                                    <img loading="lazy" src={`${globalVariable.imagesPath}products/noImage.jpg`} className="img-fluid" alt="" />
                                </div>
                            ) : (
                                <div className="content-slider-image-product">
                                    <Link to={`/${t('routes:pretraga')}?q=${productDetailItem.items[0].acDept}&brand=${productDetailItem.items[0].acDept}`}>
                                        <img loading="lazy" src={`${globalVariable.imagesPath}manufacturers/${productDetailItem.items[0].acDept.replace(' 1****', '')}.png`} className="brand-logo-product-detail img-fluid" alt="" />
                                    </Link>
                                    <ProductDetailSlider product={productDetailItem.items[0]} youtubeImage={youtubeImage} />
                                </div>
                            )
                            }
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ padding: "0px", marginTop: "5px" }}>
                                <div className="product-content-detail-main">
                                    <div className="row" style={{ margin: "0px" }}>
                                        <div className="col-lg-12 no-padding">
                                            <div className="product-compare-action-line">
                                                <div className="product-action-detail-items">
                                                    <div className="product-action-item product-ident-action">{t('productDetailPage:sifra')}: {productDetailItem.items[0].acProduct.trim()}</div>
                                                    {getUserInfo.userInfo && productDetailItem.items[0].specialList != null && productDetailItem.items[0].specialList.length > 0 && (
                                                        productDetailItem.items[0].specialList.map((item, key) => (
                                                            item.acSpecialName != 'Vaucer' && (
                                                                <div className="product-action-item product-new-action" title={item.acText} style={{ backgroundColor: `${item.acColor}` }}><i className={item.acIconClass}></i> {item.acSpecialName}</div>
                                                            )))
                                                        // <div className="product-action-item product-new-action" title={item.acText} style={{ backgroundColor: `${item.acColor}` }}><i className={item.acIconClass}></i> {item.acSpecialName}</div>
                                                    )}
                                                    {getUserInfo.userInfo && productDetailItem.items[0].additionInfo.acAction != null && productDetailItem.items[0].additionInfo.acAction.length > 0 && (
                                                        productDetailItem.items[0].additionInfo.acAction.map((item, key) => (
                                                            <>
                                                                {item.acIconType == 0 && (
                                                                    item.acAdditionalInfoName === 'DNEVNA AKCIJA' ? (
                                                                        <a href={`tel:${clerkResponsible?.acPhone2 || clerkResponsible?.acPhone1 || ''}`} className="daily-action-clerk-call daily-action-clerk-call-detail" key={key} style={{ '--clerk-badge-color': item.acColor }}>
                                                                            <div
                                                                                className="daily-action-clerk-call-avatar"
                                                                                style={{ backgroundImage: `url(${clerkResponsible?.acPicture ? `https://resource.ewe.rs/images/hr/avatars/${clerkResponsible.acPicture}` : process.env.PUBLIC_URL + '/no-user-image.png'})` }}
                                                                            ></div>
                                                                            <span>{t('catalog:pozoviteKomercijalistu')}</span>
                                                                        </a>
                                                                    ) : (
                                                                        <div className="product-action-item product-new-action" title={item.acText} style={{ backgroundColor: `${item.acColor}` }}><i className={item.acIcon}></i> {item.acAdditionalInfoName}</div>
                                                                    )
                                                                )}
                                                            </>
                                                        ))
                                                    )}
                                                </div>
                                                <div className="product-action-item-buttons">
                                                    {getUserInfo.userInfo && (
                                                        <div className="btn-product-wishlist">
                                                            <WishListButton title={t('listaZelja')} product={productDetailItem.items[0]} />
                                                        </div>
                                                    )}
                                                    <div className="btn-product-compare">
                                                        <CompareButton title={t('uporedi')} product={productDetailItem.items[0]} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ margin: "0px" }}>
                                        <div className="col-md-7 no-padding">
                                            <div className="row" style={{ margin: "0px" }}>
                                                <div className="col-md-12 no-padding" style={{ padding: "0px", marginTop: "15px" }}>
                                                    <div className="product-detail-name">
                                                        <div className="product-detail-name-category-small">
                                                            {productDetailItem.items[0].acMainCategory} / <Link to={`/${t('routes:katalog')}/podkategorija/${productDetailItem.items[0].anCategoryKey}/${removeSpecialChar(productDetailItem.items[0].acCategory)}`}>
                                                                {productDetailItem.items[0].acCategory}
                                                            </Link> / <Link to={`/${t('routes:katalog')}/podpodkategorija/${productDetailItem.items[0].anSubCategoryKey}/${removeSpecialChar(productDetailItem.items[0].acSubCategory)}`}>
                                                                {productDetailItem.items[0].acSubCategory}
                                                            </Link>
                                                        </div>
                                                        <h1>
                                                            {/* {productDetailItem.items[0].acDept.replace(" 1****", "")} {productDetailItem.items[0].acName} */}
                                                            {productDetailItem.items[0].acSeoHeader ? productDetailItem.items[0].acSeoHeader.replace(" 1****", "") : (productDetailItem.items[0].acDept.replace(" 1****", "") + productDetailItem.items[0].acName)}
                                                        </h1>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 no-padding" style={{ padding: "0px", marginTop: "5px" }}>
                                                    <div className="product-detail-icons">
                                                        <div className="product-icon-item">
                                                            {productSpecificationList.filterIcons && productSpecificationList.filterIcons.map((item, key) => {
                                                                return <ProductDetailIcon key={key} src={`${item}.png`} alt={item.acSeoDescription} title={item.acSeoTitle} />;
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 no-padding" style={{ padding: "0px", marginTop: "5px" }}>
                                                    <div className="product-detail-short-desc">
                                                        {productDetailItem.items[0].acSeoShortPageDescription ? productDetailItem.items[0].acSeoShortPageDescription : ""}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ margin: "0px" }}>
                                                <div className="col-md-12" style={{ padding: "0px" }}>
                                                    <div className="" style={{ padding: "0px", marginTop: "5px" }}>
                                                        <ProductDetailShorDescription items={productDetailItem.items[0].specification} acEan={productDetailItem.items[0].acEan} />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 no-padding-block">
                                                    <div className="" style={{ padding: "0px", marginTop: "5px" }}>
                                                        <div className="icons-holder-product-detail">
                                                            {/* {productDetailItem.items[0].additionInfo.acAction && productDetailItem.items[0].additionInfo.acAction.map((item, key) => (
                                                                <>
                                                                    {item.acIconType == 1 && (
                                                                        <img src={`${globalVariable.domainName}/media/${item.acIconImage}`} className="img-fluid" alt="Ewe Comp DOO" />
                                                                    )}
                                                                </>
                                                            ))} */}
                                                            {getUserInfo.userInfo && totalStock != 0 && productDetailItem.items[0].benefitPoints.length > 0 &&
                                                                <>

                                                                    {/* {productDetailItem.items[0].benefitPoints[0].anPoints == 5 && ( */}
                                                                    <div title={`U toku je prikupljanje poena za akciju. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='product-badge-coin-holder-formula'>
                                                                        <img alt={`${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} src={`https://resource.ewe.rs${productDetailItem.items[0].benefitPoints[0].acImage}`} title={`U toku je prikupljanje poena. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='voucher-info-box-image'></img>
                                                                        <span className='product-badge-coin-value-formula'>{productDetailItem.items[0].benefitPoints[0].anPoints}</span>
                                                                    </div>
                                                                    {/* )} */}
                                                                    {/* {productDetailItem.items[0].benefitPoints[0].anPoints == 10 && (
                                                                        <div title={`U toku je prikupljanje poena za Sencor akciju. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='product-badge-coin-holder'>
                                                                            <img alt='Deset poena' src='https://resource.ewe.rs/benefitpoint/sencor_aprililili_10.png' title={`U toku je prikupljanje poena za Sencor akciju. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='voucher-info-box-image'></img>
                                                                            <span className='product-badge-coin-value'>{productDetailItem.items[0].benefitPoints[0].anPoints}</span>
                                                                        </div>
                                                                    )} */}

                                                                    {/* {productDetailItem.items[0].benefitPoints[0].anPoints == 20 && (
                                                                        <div title={`U toku je prikupljanje poena za Sencor akciju. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='product-badge-coin-holder'>
                                                                            <img alt='Dvadeset poena' src='https://resource.ewe.rs/benefitpoint/sencor_aprililili_20.png' title={`U toku je prikupljanje poena za Sencor akciju. Ovaj artikal vam donosi ${productDetailItem.items[0].benefitPoints[0].anPoints} poena`} className='voucher-info-box-image'></img>
=                                                                        </div>
                                                                    )} */}
                                                                </>



                                                            }
                                                            {productDetailItem.items[0].additionInfo.acAction && productDetailItem.items[0].additionInfo.acAction.map((item, key) => (
                                                                <>
                                                                    {item.acIconType == 1 && (
                                                                        <Link to={item.acLink.includes("http") ? { pathname: item.acLink, } : item.acLink} target="_blank">
                                                                            <div className="product-catalog-badge-image" title={item.acAdditionalInfoName}
                                                                                onMouseEnter={() => showText(key)}
                                                                                onMouseLeave={hideText}
                                                                            ><img loading="lazy" src={`${globalVariable.domainName}/media/${item.acIconImage}`} className="img-fluid" alt={item.acSeoDescription} title={item.acSeoTitle} /></div>
                                                                        </Link>
                                                                    )}

                                                                </>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="product-detail-document-holder">
                                                    {productDetailItem.items[0].additionInfo.acDocument && productDetailItem.items[0].additionInfo.acDocument.map((item, key) => (
                                                        // <Document file={`${globalVariable.domainName}/media/${item.acImage}`} onLoadSuccess={onDocumentLoadSuccess}>
                                                        <div className="" >
                                                            <div className="document-holder-item">
                                                                <a href={`${globalVariable.domainName}/media/${item.acImage}`} target="_blank">
                                                                    <Document
                                                                        file={`${globalVariable.domainName}/media/${item.acImage}`}
                                                                    >
                                                                        <Page
                                                                            pageNumber={1}
                                                                            height="90"
                                                                            className="canvas-holder"
                                                                            size="A4"
                                                                        />
                                                                    </Document>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5 no-padding">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <ProductDetailPriceBlock getUserInfo={getUserInfo} productItem={productDetailItem.items[0]} />
                                                </div>
                                                <div className="col-md-12">
                                                    {getUserInfo.userInfo && <ProductDetailMarginBlock product={productDetailItem.items[0]} productId={newProductId} />}
                                                </div>
                                                <div className="col-md-12">
                                                    <div style={{ float: "right" }} className="button-export-product-detail ">
                                                        {getUserInfo.userInfo && (
                                                            <Link to={`/${t('routes:proizvodCustom')}/${removeSpecialChar(productDetailItem.items[0].acName)}`}
                                                                target={"_blank"}
                                                                className="btn-product-exp btn-offer-product-detail"
                                                                onClick={(e) => gatherStatisticMakeOffer()}>
                                                                <div style={{ textAlign: "center" }} className='product-detail-page-create-price'>
                                                                    <img src={`${iconPath}icon-uredite-korpu.svg`} alt={t('productDetailPage:ikonicaUrediteKorpu')} /> {t('productDetailPage:napraviPonudu')}
                                                                </div>
                                                            </Link>
                                                        )}
                                                        <a href={`/${t('routes:proizvodDetaljnoPdf')}/${newProductId}/${removeSpecialChar(productDetailItem.items[0].acName)}`} target="_blank" rel='noreferrer' className="btn-product-exp btn-pdf-product-detail">
                                                            <div style={{ textAlign: "center" }} className='pdf-view'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.55 53.84"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M19.32 13.92A8.06 8.06 0 0117 16.21l2 2.93a11.76 11.76 0 003.26-3.26zM4.87 21.14c3.5 0 6.25 0 8.45-.23A11.9 11.9 0 0019 19.14l-2-2.93a8.54 8.54 0 01-4 1.2c-2 .2-4.52.2-8.09.2zM20.72 1.76c0 3.57 0 6.12-.2 8.09a8.62 8.62 0 01-1.2 4.07l2.93 2A12 12 0 0024 10.21c.23-2.2.22-5 .22-8.45zM4.87 17.61H1.76v3.53h3.11zm15.92-2.71l-1.47-1z" className="cls-1"></path> <path d="M1.64 15.11A11.27 11.27 0 00.74 17L4 18.23a8.09 8.09 0 01.63-1.33zm1.88 9.83c0-3.89 0-5.39.52-6.71L.74 17C0 19.06 0 21.32 0 24.94zM7.33 9.53c-2.81 2.28-4.58 3.69-5.69 5.58l3 1.79c.72-1.22 1.87-2.19 4.88-4.64zm12.59-5.32A8 8 0 0121 3.83L20 .44a12.09 12.09 0 00-1.49.56zM26.09 0A22.45 22.45 0 0020 .44l1 3.39a20 20 0 015.1-.31zM15.77 7.2c2.27-1.85 3.15-2.56 4.15-3L18.51 1a23 23 0 00-5 3.48zm24.84-2.09A8.45 8.45 0 0142.45 7l2.85-2.13a12 12 0 00-2.62-2.61zm6.94 14.77a89.39 89.39 0 00-.25-9 12 12 0 00-2-6L42.45 7a8.56 8.56 0 011.35 4.3c.23 2.1.23 4.81.23 8.63zM27.68 3.52c3.81 0 6.53 0 8.63.23a8.55 8.55 0 014.3 1.36l2.07-2.85a11.94 11.94 0 00-6-2C34.35 0 31.41 0 27.68 0zM42.45 46.9a8.91 8.91 0 01-1.84 1.84l2.07 2.85A12.06 12.06 0 0045.3 49zm-14.77 6.94a89.59 89.59 0 009-.25 11.93 11.93 0 006-2l-2.07-2.85a8.56 8.56 0 01-4.3 1.35c-2.1.23-4.82.23-8.63.23zM44 34c0 3.81 0 6.53-.23 8.63a8.56 8.56 0 01-1.35 4.3L45.3 49a11.93 11.93 0 002-6 89.59 89.59 0 00.25-9zM7 48.74a8.45 8.45 0 01-1.89-1.84L2.26 49a12 12 0 002.61 2.62zM0 34c0 3.73 0 6.67.25 9a11.94 11.94 0 002 6l2.86-2.1a8.55 8.55 0 01-1.36-4.3c-.22-2.1-.23-4.82-.23-8.63zm19.88 16.32c-3.82 0-6.53 0-8.63-.23A8.56 8.56 0 017 48.74l-2.13 2.85a12 12 0 006 2 89.39 89.39 0 009 .25zM3.52 34v-9H0v9zm24.16 16.32h-7.8v3.52h7.8zM44 19.88V34h3.52V19.88zM26.09 3.52h1.59V0h-1.59zM9.55 12.26l6.22-5.06-2.23-2.74-6.21 5.07zm-7.16 5.35L.74 17zM20.51 2.14L20 .44zm-1.29.46L18.51 1zm-4.57 3.23l-1.11-1.37zm29.22.08L42.45 7zm-2.23-2.23l-1 1.43zm0 46.48l1 1.43zm2.23-2.22l1.43 1zm-40.19 0L2.26 49zm2.23 2.22l1-1.42z" className="cls-1"></path><path
                                                                    d="M17.77 31.15c0 1.78-1.09 3.73-4.49 3.73h-3v3.59a.78.78 0 01-.78.76.75.75 0 01-.75-.76V28.19a.76.76 0 01.75-.77h3.83c3.35 0 4.44 1.95 4.44 3.73zm-1.53 0c0-1.1-.6-2.29-3.11-2.29h-2.9v4.57h2.9c2.51 0 3.11-1.19 3.11-2.28zM29.72 33.28a5.69 5.69 0 01-5.93 5.86h-3.38a.74.74 0 01-.75-.75v-10.2a.76.76 0 01.75-.77h3.38a5.68 5.68 0 015.93 5.86zm-1.51 0a4.27 4.27 0 00-4.61-4.43h-2.42v8.87h2.42a4.28 4.28 0 004.61-4.44zM33.5 28.85v3.71h5.18a.72.72 0 01.72.72.71.71 0 01-.72.71H33.5v4.48a.77.77 0 01-.77.76.75.75 0 01-.75-.76V28.19a.76.76 0 01.75-.77h6.54a.72.72 0 01.72.72.71.71 0 01-.72.71z" className="cls-2"></path></g></g>
                                                                </svg> {t('productDetailPage:izveziPDF')}
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Potrebno dodati handler za tip U - čekamo odluku */}
                                    {productDetailItem.items[0] != undefined ?
                                        productDetailItem.items[0].specialList.length > 0 && productDetailItem.items[0].specialList[0].acType == 'C' &&
                                        <div className='voucher-info-box'>
                                            <div className='voucher-info-box-content new-action' title={productDetailItem.items[0].specialList[0].acSpecialName}>
                                                <img alt='voucher icon' src='https://resource.ewe.rs/vouchers/logo.png' className='voucher-info-box-image'></img>
                                                <div className='voucher-info-box-content-text'>
                                                    <p>{productDetailItem.items[0].specialList[0].anValue}</p>
                                                    <span>{productDetailItem.items[0].specialList[0].acNote}</span>
                                                </div>
                                            </div>
                                        </div>
                                        : ""
                                    }

                                </div>
                            </div>
                        </div>
                        {/* <div className="row" style={{ backgroundColor: "#f6f6f6" }}>
                            <div className="product-detail-document-holder">
                                {productDetailItem.items[0].additionInfo.acDocument && productDetailItem.items[0].additionInfo.acDocument.map((item, key) => (
                                    // <Document file={`${globalVariable.domainName}/media/${item.acImage}`} onLoadSuccess={onDocumentLoadSuccess}>
                                    <div className="" >
                                        <div className="document-holder-item">
                                            <a href={`${globalVariable.domainName}/media/${item.acImage}`} target="_blank">
                                                <Document
                                                    file={`${globalVariable.domainName}/media/${item.acImage}`}
                                                >
                                                    <Page
                                                        pageNumber={1}
                                                        height="90"
                                                        className="canvas-holder"
                                                        size="A4"
                                                    />
                                                </Document>
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div> */}
                        <div className="row">
                            <div className="col-lg-12 content-tabs-sector">
                                <div className="product-detail-tabs-content-container">
                                    <div className="product-detail-tabs-list">
                                        {productDetailItem.items[0].additionInfo.anPage ? (
                                            <>
                                                <div className={`product-detail-tab-item ${tab == 1 && "active"}`} onClick={(e) => { setTab(1); gatherStatisticDesc(); }}>
                                                    {t('productDetailPage:opisProizvoda')}
                                                </div>
                                                <div className={`product-detail-tab-item ${tab == 2 && "active"}`} onClick={(e) => { setTab(2); gatherStatisticSpec(); }}>
                                                    {t('productDetailPage:specifikacija')}
                                                </div>
                                            </>
                                        ) : (
                                            <div className={`product-detail-tab-item ${tab == 1 && "active"}`} onClick={(e) => setTab(1)}>
                                                {t('productDetailPage:specifikacija')}
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="product-detail-tabs-body">
                                        {productDetailItem.items[0].acProductDescription != '' && productDetailItem.items[0].acProductDescription != null && (
                                            <div className="alert-info-specification alert alert-warning info-danger-outlet-description" >
                                                <i className="fas fa-info-circle"></i>
                                                <div dangerouslySetInnerHTML={{ __html: productDetailItem.items[0].acProductDescription }}></div>
                                            </div>
                                        )}
                                        {productDetailItem.items[0].additionInfo.anPage ?
                                            tab == 1 ? (
                                                <div className={`product-detail-tab-desc ${tab == 1 && "active"}`} style={{ margin: "0px", padding: "0px", overflow: "hidden" }}>
                                                    {productDetailItem.items[0].additionInfo.anPage &&
                                                        <IframeResizer
                                                            src={
                                                                productDetailItem.items[0].additionInfo.anPage[0].acImage.includes('www.ewe.rs')
                                                                    ? productDetailItem.items[0].additionInfo.anPage[0].acImage.replace('www.ewe.rs', 'resource.ewe.rs')
                                                                    : productDetailItem.items[0].additionInfo.anPage[0].acImage
                                                            }
                                                            style={{ minWidth: "1px", width: "100%" }} />}
                                                </div>
                                            ) : (
                                                <ProductDetailSpecification tab={tab} id={newProductId} product={productDetailItem.items[0]} />
                                            )
                                            :
                                            <ProductDetailSpecification tab={tab} id={newProductId} product={productDetailItem.items[0]} />
                                        }
                                        <div className="disclaimer">
                                            <p>{t('productDetailPage:eweComp')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {getSale.length > 0 && (
                                <div className="col-lg-12 related-sale-products">
                                    <div className="related-sale-header">
                                        <p id="related-sale-title">{t('productDetailPage:kupovinomOvogUredjaja')}</p>
                                        {/* {relatedSale ?
                                            <span className="btn related-sale-toggle-show" onClick={closeRelatedSale}>Sakrij sve</span>
                                            :
                                            <span className="btn related-sale-toggle-show" onClick={showRelatedSale}>Prikaži sve</span>
                                        } */}
                                    </div>
                                    {/* {relatedSale && */}
                                    <div className="row">
                                        {/* {getSale.map((item, index) => (
                                                <RelatedSaleItems key={index} item={item} />
                                            ))} */}

                                        {getSale.slice(0, itemsToShow).map((item, index) => (
                                            <RelatedSaleItems key={index} item={item} />
                                        ))}
                                        {/*U SLUCAJU DA NE BUDE PRIKAZIVALO DUGMICE PRIKAZI VISE/MANJE UKLONITI USLOV ISPOD (LOGIKA JE ONDA FALICNA) */}
                                        {getSale.length >= itemsToShow &&
                                            <div className="col-sm-12 show-more-specification-product-detail-btn">
                                                {itemsToShow < getSale.length ?
                                                    <div className="btn-show-more-spec" onClick={showMore}>{t('productDetailPage:prikaziVise')} <i className="fas fa-plus"></i></div>
                                                    :
                                                    <div className="btn-show-more-spec" onClick={showLess}>{t('productDetailPage:prikaziManje')} <i className="fas fa-minus"></i></div>
                                                }
                                            </div>
                                        }

                                        {/* U slucaju da zele da bude slider*/}
                                        {/* <div className="product-promo-holder">
                                            <BlockActionSlider type="relatedSale" title="Promo" bigImage="" bannerTitle="" position="0" />
                                        </div> */}
                                    </div>
                                    {/* } */}
                                </div>
                            )}
                            {getRelatedProducts.length > 1 && (
                                <div className="container-fluid related-products-list">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <BlockActionSlider type="relatedProducts" title={t('productDetailPage:slicniProizvodi')} />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {getLastProducts.items.length > 0 && (
                                <div className="container-fluid related-products-list">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <BlockActionSlider type="viewedProducts" title={t('productDetailPage:poslednjePregledni')} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
}

export default ProductDetailPage;